import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function App() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <div className="w-full scroll-smooth" data-id="element-0">
      {/* Hero Section - Purple */}
      <section className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-[#880088]" data-id="element-1">
        {/* Abstract texture background */}
        <div className="absolute inset-0 opacity-30" data-id="element-2">
          <div className="absolute top-0 -left-4 w-96 h-96 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse" data-id="element-3" />
          <div className="absolute top-0 -right-4 w-96 h-96 bg-pink-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-1000" data-id="element-4" />
          <div className="absolute -bottom-8 left-20 w-96 h-96 bg-purple-700 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-500" data-id="element-5" />
        </div>

        {/* Noise texture overlay */}
        <div className="absolute inset-0 opacity-20 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIj48ZmlsdGVyIGlkPSJhIiB4PSIwIiB5PSIwIj48ZmVUdXJidWxlbmNlIGJhc2VGcmVxdWVuY3k9Ii43NSIgc3RpdGNoVGlsZXM9InN0aXRjaCIgdHlwZT0iZnJhY3RhbE5vaXNlIi8+PGZlQ29sb3JNYXRyaXggdHlwZT0ic2F0dXJhdGUiIHZhbHVlcz0iMCIvPjwvZmlsdGVyPjxwYXRoIGQ9Ik0wIDBoMzAwdjMwMEgweiIgZmlsdGVyPSJ1cmwoI2EpIiBvcGFjaXR5PSIuMDUiLz48L3N2Zz4=')]" data-id="element-6" />

        {/* Centered Logo - reduced by 30% more */}
        <div className="relative z-10 w-full max-w-sm px-8 -mt-16" data-id="element-7">
          <img src="https://cdn.magicpatterns.com/uploads/vdaoNLY4rqwpt59jYUYzyU/Eon_Logo_White_Above.png" alt="Eon 418" className="w-full h-auto drop-shadow-2xl" data-id="element-8" />
        </div>

        {/* Bottom Chevron */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-white/50 z-10" data-id="element-9">
          <ChevronDown className="h-8 w-8" strokeWidth={1.5} data-id="element-10" />
        </div>

        {/* Gradient transition to black */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent to-black pointer-events-none z-10" data-id="element-11" />
      </section>

      {/* About Section - Black with Tech Mystery */}
      <section className="relative w-full min-h-screen flex items-center justify-center px-4 py-24 bg-black overflow-hidden" data-id="element-12">
        {/* Glowing orbs */}
        <div className="absolute inset-0 opacity-20" data-id="element-13">
          <div className="absolute top-20 left-10 w-96 h-96 bg-purple-600/40 rounded-full mix-blend-lighten filter blur-3xl animate-pulse" style={{
          animationDuration: '8s'
        }} data-id="element-14" />
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-500/30 rounded-full mix-blend-lighten filter blur-3xl animate-pulse" style={{
          animationDuration: '6s',
          animationDelay: '1s'
        }} data-id="element-15" />
        </div>

        {/* Circuit board pattern */}
        <div className="absolute inset-0 opacity-10" data-id="element-16">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-17">
            <defs data-id="element-18">
              <pattern id="circuit" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse" data-id="element-19">
                <path d="M10 10h20v20h-20z M40 10h20v20h-20z M70 10h20v20h-20z M10 40h20v20h-20z M70 40h20v20h-20z M40 70h20v20h-20z" stroke="rgba(139, 92, 246, 0.3)" strokeWidth="0.5" fill="none" data-id="element-20" />
                <circle cx="30" cy="20" r="2" fill="rgba(139, 92, 246, 0.5)" data-id="element-21" />
                <circle cx="60" cy="20" r="2" fill="rgba(139, 92, 246, 0.5)" data-id="element-22" />
                <circle cx="20" cy="50" r="2" fill="rgba(139, 92, 246, 0.5)" data-id="element-23" />
                <circle cx="80" cy="50" r="2" fill="rgba(139, 92, 246, 0.5)" data-id="element-24" />
                <line x1="30" y1="20" x2="60" y2="20" stroke="rgba(139, 92, 246, 0.3)" strokeWidth="0.5" data-id="element-25" />
                <line x1="20" y1="50" x2="80" y2="50" stroke="rgba(139, 92, 246, 0.3)" strokeWidth="0.5" data-id="element-26" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#circuit)" data-id="element-27" />
          </svg>
        </div>

        {/* Digital grid with glow */}
        <div className="absolute inset-0 opacity-[0.07] bg-[linear-gradient(rgba(139,92,246,.4)_1px,transparent_1px),linear-gradient(90deg,rgba(139,92,246,.4)_1px,transparent_1px)] bg-[size:50px_50px]" data-id="element-28" />

        {/* Animated scan lines */}
        <div className="absolute inset-0 opacity-5" data-id="element-29">
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/20 to-transparent animate-pulse" style={{
          animationDuration: '4s'
        }} data-id="element-30" />
        </div>

        {/* Hexagonal pattern overlay */}
        <div className="absolute inset-0 opacity-5 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iMTAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0yOCAwTDAgMTVWMzVMMjggNTBMNTYgMzVWMTVaIiBmaWxsPSJub25lIiBzdHJva2U9InJnYmEoMTM5LDkyLDI0NiwwLjMpIiBzdHJva2Utd2lkdGg9IjAuNSIvPjwvc3ZnPg==')]" data-id="element-31" />

        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-32">
          <p className="text-white text-base md:text-xl leading-relaxed font-light tracking-wide" data-id="element-33">
            Eon 418 is a visionary company based in the United Arab Emirates,
            <br data-id="element-34" />
            partnering with innovators to unlock transformative breakthroughs
            <br data-id="element-35" />
            at the frontier of advanced technology.
          </p>
        </div>

        {/* Subtle divider */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-purple-500/40 to-transparent z-10" data-id="element-36" />
      </section>

      {/* Contact Section - Black with Tech Mystery */}
      <section className="relative w-full min-h-screen flex items-center justify-center px-4 py-24 bg-black overflow-hidden" data-id="element-37">
        {/* Technological mystery background */}
        <div className="absolute inset-0 opacity-15" data-id="element-38">
          <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-purple-600/50 rounded-full mix-blend-lighten filter blur-3xl animate-pulse" style={{
          animationDuration: '7s'
        }} data-id="element-39" />
          <div className="absolute top-1/3 right-1/4 w-96 h-96 bg-cyan-500/40 rounded-full mix-blend-lighten filter blur-3xl animate-pulse" style={{
          animationDuration: '9s',
          animationDelay: '2s'
        }} data-id="element-40" />
        </div>

        {/* Circuit pattern */}
        <div className="absolute inset-0 opacity-8" data-id="element-41">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-42">
            <defs data-id="element-43">
              <pattern id="circuit2" x="0" y="0" width="120" height="120" patternUnits="userSpaceOnUse" data-id="element-44">
                <path d="M15 15h25v25h-25z M60 15h25v25h-25z M15 60h25v25h-25z M60 60h25v25h-25z" stroke="rgba(139, 92, 246, 0.25)" strokeWidth="0.5" fill="none" data-id="element-45" />
                <circle cx="40" cy="27" r="1.5" fill="rgba(139, 92, 246, 0.4)" data-id="element-46" />
                <circle cx="72" cy="72" r="1.5" fill="rgba(139, 92, 246, 0.4)" data-id="element-47" />
                <line x1="40" y1="27" x2="72" y2="72" stroke="rgba(139, 92, 246, 0.2)" strokeWidth="0.5" data-id="element-48" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#circuit2)" data-id="element-49" />
          </svg>
        </div>

        {/* Digital grid */}
        <div className="absolute inset-0 opacity-[0.06] bg-[linear-gradient(rgba(139,92,246,.3)_1px,transparent_1px),linear-gradient(90deg,rgba(139,92,246,.3)_1px,transparent_1px)] bg-[size:60px_60px]" data-id="element-50" />

        <div className="w-full max-w-2xl mx-auto relative z-10" data-id="element-51">
          {isSubmitted ? <div className="text-center space-y-4" data-id="element-52">
              <h2 className="text-3xl font-light text-white" data-id="element-53">Thank you</h2>
              <p className="text-white/60" data-id="element-54">
                We have received your message and will be in touch shortly.
              </p>
            </div> : <div className="space-y-8" data-id="element-55">
              <div className="text-center" data-id="element-56">
                <h2 className="text-3xl font-light text-white mb-2" data-id="element-57">
                  Contact Us
                </h2>
                <p className="text-white/60 text-sm" data-id="element-58">
                  Get in touch with our team
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-59">
                {/* Name and Email in same row */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-60">
                  <div className="space-y-2" data-id="element-61">
                    <label htmlFor="name" className="text-sm text-white/80 uppercase tracking-wider" data-id="element-62">
                      Name
                    </label>
                    <input required type="text" id="name" className="w-full bg-transparent border-b border-white/30 py-2 text-white placeholder:text-white/30 focus:border-white focus:outline-none transition-colors" placeholder="Enter your name" data-id="element-63" />
                  </div>

                  <div className="space-y-2" data-id="element-64">
                    <label htmlFor="email" className="text-sm text-white/80 uppercase tracking-wider" data-id="element-65">
                      Email
                    </label>
                    <input required type="email" id="email" className="w-full bg-transparent border-b border-white/30 py-2 text-white placeholder:text-white/30 focus:border-white focus:outline-none transition-colors" placeholder="Enter your email" data-id="element-66" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-67">
                  <label htmlFor="message" className="text-sm text-white/80 uppercase tracking-wider" data-id="element-68">
                    Message
                  </label>
                  <textarea required id="message" rows={4} className="w-full bg-transparent border-b border-white/30 py-2 text-white placeholder:text-white/30 focus:border-white focus:outline-none transition-colors resize-none" placeholder="How can we help?" data-id="element-69" />
                </div>

                <div className="flex justify-center pt-4" data-id="element-70">
                  <button type="submit" className="px-8 py-3 bg-white text-black text-xs uppercase tracking-widest font-medium hover:bg-white/90 transition-all duration-300 hover:scale-105" data-id="element-71">
                    Submit
                  </button>
                </div>
              </form>
            </div>}
        </div>
      </section>

      {/* Copyright Footer */}
      <footer className="bg-black py-8 border-t border-white/10 relative overflow-hidden" data-id="element-72">
        {/* Subtle tech pattern in footer */}
        <div className="absolute inset-0 opacity-5 bg-[linear-gradient(rgba(139,92,246,.2)_1px,transparent_1px),linear-gradient(90deg,rgba(139,92,246,.2)_1px,transparent_1px)] bg-[size:40px_40px]" data-id="element-73" />

        <div className="text-center relative z-10" data-id="element-74">
          <p className="text-white/40 text-sm" data-id="element-75">
            © 2026 Eon 418. All rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}